import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import FeatureGrid from './components/FeatureGrid';
import ComparisonSection from './components/ComparisonSection';
import SafetySection from './components/SafetySection';
import CtaSection from './components/CtaSection';
import ArticlePreview from './components/ArticlePreview';
import Footer from './components/Footer';
import HomeSchema from '@/components/feature/HomeSchema';

export default function Home() {
  return (
    <main>
      <HomeSchema />
      <Hero />
      <CategoryGrid />
      <AboutSection />
      <FeatureGrid />
      <ComparisonSection />
      <SafetySection />
      <CtaSection />
      <ArticlePreview />
      <Footer />
    </main>
  );
}